import React from "react";
import useUserDetails from "../../utils/hooks/user/useUserDetails";
import Toggle from "../forms/inputs/Toggle";

const NotificationInfoCard = () => {
  const { username, email_notifications_enabled, setDetails } = useUserDetails();

  return (
    <div className="mt-6 p-5 rounded-xl bg-white border border-[#E5E7EB] shadow-sm space-y-5" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {/* Header */}
      <div className="flex items-start gap-3">
        <div className="mt-0.5">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#58CC02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 16V12" stroke="#58CC02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8H12.01" stroke="#58CC02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div>
          <h3 className="text-sm font-bold text-[#111827]">How it works</h3>
          <p className="text-[11px] leading-relaxed text-[#6B7280] mt-1">
            Enable a module to receive all related emails. You can also customize preferences for individual events.
          </p>
        </div>
      </div>

      <div className="h-[1px] bg-[#F3F4F6] w-full" />

      {/* Global Settings */}
      <div>
        <h4 className="text-[11px] font-bold text-[#111827] mb-1">Global Email Settings</h4>
        <p className="text-[10px] text-[#6B7280] mb-3">Turning this off will stop all non-essential platform emails.</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            <span className="text-[12px] text-[#374151]">Email</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="scale-75">
              <Toggle 
                value={email_notifications_enabled !== false} 
                onChange={(val: boolean) => username && setDetails({ username, email_notifications_enabled: val }, true)} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationInfoCard;
